import { render } from "./ChooseDigitalPaymentAmount.vue?vue&type=template&id=fe628f6c&scoped=true"
import script from "./ChooseDigitalPaymentAmount.vue?vue&type=script&lang=js"
export * from "./ChooseDigitalPaymentAmount.vue?vue&type=script&lang=js"

import "./ChooseDigitalPaymentAmount.vue?vue&type=style&index=0&id=fe628f6c&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe628f6c"]])

export default __exports__